module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "element element-bodymatter element-container-single element-type-chapter element-with-heading",
    attrs: {
      "id": "chapter-2"
    }
  }, [_c('div', {
    staticClass: "heading heading-with-title heading-without-image",
    attrs: {
      "id": "chapter-2-heading"
    }
  }, [_c('div', {
    staticClass: "heading-contents"
  }, [_c('div', {
    staticClass: "title-subtitle-block title-block-title-is-element-number"
  }, [_c('div', {
    staticClass: "element-number-block"
  }), _vm._v(" "), _c('div', {
    staticClass: "title-block"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("Chapter Two")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "text",
    attrs: {
      "id": "chapter-2-text"
    }
  }, [_c('p', {
    staticClass: "first first-in-chapter first-full-width"
  }, [_c('span', {
    staticClass: "drop-cap"
  }, [_vm._v("“Y")]), _vm._v("ou will stay here tonight,” the Sheikh commanded. His firm expression dared anyone to question his decision.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“I am here with my classmates.” Ellena tore her gaze from Kamran. “We’re supposed to see the sights,” she protested. “They’re probably worried.”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“You will be in good hands with Kamran Ali Khan.”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“But —”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“Say thank you, Ellena,” Kamran whispered, under the Sheikh’s fierce frown.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("She shifted her gaze to his, saw the warning in his eyes. “Thank you.” Then she gave him the Arabic greeting.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("The Sheikh flinched, then refocused as he smiled and replied in kind. He slid back onto the throne. “See, she even knows a little Arabic. The proper way to greet. Now your love of Western culture will be put to good use, my son.”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“Can he force me to stay here?” she said in Kamran’s ear.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“It would be an insult to refuse his hospitality.”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“But I don’t know any of the customs here—”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“Shhhhh,” Kamran whispered, taking her hand in his. “It is fine. You will be fine.”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“He can’t just throw you away like this,” she murmured, searching his eyes for some form of deception. “You don’t know me.”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Kamran gave her hand a gentle squeeze and guided her to the foyer under the curious gazes of everyone else. “Ellena, nine days is a long time. Today, I will walk you through the palace grounds and then you will give me your original itinerary. I will be certain to take you every place you had planned to see.” His dark-brown gaze lasered in on her. “Will that be all right?”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“That sounds nice, but what about the people I was traveling with? This is a class reunion. I haven’t seen some of them in ten years. That’s the sole purpose of this trip.”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“A few inquired at the hospital,” Kamran said, walking past the guards at the pathway leading to the exit. “They know you are with the Royal family. Come, my mother will have a room prepared for you. Tomorrow, we will check into Jumillah.”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“What’s that?”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“The most precious hotel in Durabia,” he said. “And since it is on a private island, it affords the right kind of seclusion.”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("She nodded, trying to balance herself. All of this was overwhelming.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“Oh, and we are going to the Durabia Mall for you to pick up a few tunics, all right?”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Ellena stopped walking. “What is wrong with …”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“You will be interacting with the Royal family,” he said in a patient tone. “You must cover certain …” He lowered his gaze to the cleavage baring blouse. “"), _c('i', [_vm._v("Assets")]), _vm._v(", accordingly.”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("She tried to pull away. “It’s all too much. It’s so fast. What if I make a mistake?”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“You will not. Please do not worry.”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Ellena scanned his face again, and could not believe how calm he was, given the circumstances. “Aren’t you angry? He just—”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“May I be honest?” he said, and his voice was deep, rich, like the smoothest whiskey.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“Yes. Sure.”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“You had me at ‘he is still a man. He still has value. A brain, intelligence, and a purpose’.”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("With that being said, Kamran gave her a slight bow as his mother came forward to guide her into an alcove that led to a suite of rooms. He walked past, leaving Ellena’s mind churning in circles.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1d872b26","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter-002.vue
// module id = 75
// module chunks = 0